// extracted by mini-css-extract-plugin
export default {"errorDetails":"error_tag_errorDetails__gAsHu"};